import React from 'react';
import { GlassGradient, GlassPanel, Handle, BattenteTriangleFill, AntaRibaltaFill, VasistasFill, FixedMark, SlidingArrow, BilicoH, BilicoV } from './primitives';

export const mosquitoNet = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <rect x={10} y={8} width={60} height={84} fill="#F5F5F5" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8,9,10,11].map(i => (<line key={`h${i}`} x1={10} y1={15+i*7} x2={70} y2={15+i*7} stroke="#CCC" strokeWidth="0.3" />))}
    {[0,1,2,3,4,5,6,7].map(i => (<line key={`v${i}`} x1={17+i*8} y1={8} x2={17+i*8} y2={92} stroke="#CCC" strokeWidth="0.3" />))}
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const externalBlind = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_eb" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_eb" />
    {[0,1,2,3,4,5,6].map(i => (<line key={i} x1={10} y1={18+i*12} x2={70} y2={14+i*12} stroke="#777" strokeWidth="2.5" />))}
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const screen = () => (
  <svg viewBox="0 0 120 80" className="w-full h-full">
    <rect x={10} y={4} width={100} height={10} fill="#A0A0A0" stroke="#333" strokeWidth="1" rx="3" />
    <path d="M10,14 L10,65 Q60,75 110,65 L110,14 Z" fill="#BDD2ED" stroke="#333" strokeWidth="1.5" />
    <line x1={20} y1={14} x2={15} y2={65} stroke="#888" strokeWidth="2" />
    <line x1={100} y1={14} x2={105} y2={65} stroke="#888" strokeWidth="2" />
  </svg>
);

export const awning = () => (
  <svg viewBox="0 0 120 80" className="w-full h-full">
    <rect x={10} y={4} width={100} height={10} fill="#A0A0A0" stroke="#333" strokeWidth="1" rx="3" />
    <path d="M10,14 L10,65 Q60,75 110,65 L110,14 Z" fill="#BDD2ED" stroke="#333" strokeWidth="1.5" />
    <line x1={20} y1={14} x2={15} y2={65} stroke="#888" strokeWidth="2" />
    <line x1={100} y1={14} x2={105} y2={65} stroke="#888" strokeWidth="2" />
  </svg>
);

export const pergola = () => (
  <svg viewBox="0 0 120 80" className="w-full h-full">
    <GlassGradient id="g_pg" />
    <rect x={10} y={10} width={6} height={65} fill="#888" stroke="#333" strokeWidth="1" />
    <rect x={104} y={10} width={6} height={65} fill="#888" stroke="#333" strokeWidth="1" />
    <rect x={8} y={6} width={104} height={8} fill="#A0A0A0" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6].map(i => (<rect key={i} x={18+i*13} y={8} width={8} height={6} fill="#C0C0C0" stroke="#999" strokeWidth="0.5" />))}
    <GlassPanel x={18} y={16} w={84} h={55} gradId="g_pg" />
  </svg>
);

